import React from 'react';

class LessonPolicy extends React.Component {
  async handleDownload() {
    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');

    logAnalyticsEvent('lesson_policy_download', {
      file_type: 'pdf'
    });

    const link = document.createElement('a');
    link.href = `/static/lessonPolicy.pdf`;
    link.download = 'lessonPolicy.pdf';
    link.click();
  };

  render() {
    return (
      <main className="fullPageContainer" style={{ overflow: 'scroll', paddingTop: 15, paddingBottom: 15 }}>
        <div className="bodyContainer">
          <h1>LESSON POLICY</h1>

          <div className="buttonContainer">
            <button onClick={this.handleDownload}>Download as PDF</button>
          </div>

          <img
            src={`/static/lessonPolicy.png`}
            alt="Lesson Policy"
          />
          {/*
            Displays wonkily with editor
            <iframe
              title="Lesson Policy"
              src={`/static/lessonPolicy.pdf`}
              width="100%"
              height="1000"
            /> */}
        </div>
      </main>
    )
  }
}

export default LessonPolicy;
